<template>
  <el-dialog
      :title="title"
      :visible.sync="visible"
      width="400px"
      @close="handlerCancel"
      class="custom-el-wrapper"
  >

    <el-input
        v-model="value"
        :type="type"
        :rows="2"
    />

    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">取 消</el-button>
      <el-button type="primary" @click="handlerConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      value:'',
      callback:null,
      title:'',
      func:null,
      assemble: null,
      type: 'text',
    }
  },
  mounted() {

  },
  methods: {
    open(title, value, func, assemble, callback, type = 'text'){
      this.title = title;
      this.value = value;
      this.func = func;
      this.assemble = assemble;
      this.callback = callback;
      this.type = type
      this.visible = true;
    },
    handlerConfirm(){
      this.func({
        data:this.assemble(this.value),
        success:(res)=>{
          this.callback(res);
          this.visible = false;
        },
      })
    },
    handlerCancel(){
      this.visible = false;
    },
  }
}
</script>

<style scoped>

</style>
